import { APP_MIGRATION_PAGE, SMART_INSIGHT } from '../../constants/Urls';
import { getNavsideIcon } from '../../utils/SideNavigationUtils';

export const prepareMenuItems = (
  dashboardLink,
  hasSupervisorRight,
  hasManageRight,
  history,
  translateString
) => {
  const navigationLinks = [];

  const dashboardItem = {
    text: 'Dashboard',
    icon: getNavsideIcon('dashboardIcon'),

    onClick: () => history.push(dashboardLink),
  };

  if (dashboardLink === SMART_INSIGHT) {
    if (hasSupervisorRight) {
      navigationLinks.push({
        text: translateString('Saved Searches'),
        icon: getNavsideIcon('savedSearches'),
        onClick: () => history.push(`${dashboardLink}?smartInsightType=savedSearches`),
      });
    }
    if (hasManageRight) {
      navigationLinks.push(
        {
          text: 'Reports',
          icon: getNavsideIcon('reportIcon'),
          onClick: () => history.push(`${dashboardLink}?smartInsightType=reports`),
        },
        {
          text: 'Report Models',
          icon: getNavsideIcon('reportModels'),

          onClick: () => history.push(`${dashboardLink}?smartInsightType=reportModels`),
        }
      );
    }
  } else if (dashboardLink === APP_MIGRATION_PAGE) {
    navigationLinks.push(dashboardItem);
    navigationLinks.push(
      {
        text: 'Packages',
        icon: getNavsideIcon('reportIcon', 'Export Application Components - by Package File'),
        onClick: () => history.push(`${dashboardLink}?type=packages`),
      },
      {
        text: 'History',
        icon: getNavsideIcon('historyIcon', 'History'),
        onClick: () => history.push(`${dashboardLink}?type=history`),
      }
    );
  } else {
    navigationLinks.push(dashboardItem);
  }

  return navigationLinks;
};
